import React, { useState } from 'react';
import { Button, Container } from '@plone/components';
import { ChevrondownIcon, ChevronrightIcon } from '@plone/components/Icons';
import { Accordion } from 'semantic-ui-react';
import Tags from '@plone/volto/components/theme/Tags/Tags';
import type { Content } from '@plone/types';

interface ServicoViewProps {
  content: Content;
}

const AccordionSection = ({ idx, title, content, isActive, handleClick }) => {
  return (
    <>
      <Accordion.Title active={isActive} index={idx} onClick={handleClick}>
        {isActive ? <ChevrondownIcon /> : <ChevronrightIcon />}
        <span className="introduction">{title}</span>
      </Accordion.Title>
      <Accordion.Content active={isActive}>
        <p dangerouslySetInnerHTML={{ __html: content.data }} />
      </Accordion.Content>
    </>
  );
};

const ServicoView: React.FC<ServicoViewProps> = ({ content }) => {
  const [state, setState] = useState({ activeIndex: 0 });
  const { activeIndex } = state;
  const { title, category, icon, description } = content;

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = state;
    const newIndex = activeIndex === index ? -1 : index;

    setState({ activeIndex: newIndex });
  };

  const allSections = [
    {
      title: 'Sobre o Serviço',
      content: content.basic_data,
    },
    {
      title: 'Quem pode utilizar este serviço?',
      content: content.users,
    },
    {
      title: 'Etapas para a utilização deste serviço',
      content: content.steps,
    },
    {
      title: 'Outras informações',
      content: content.other,
    },
  ].filter((section) => section.content?.data);

  return (
    <Container id="page-document" className={`view-wrapper servico-view`}>
      <Container className="categoria" narrow>
        <span className="card-icon">
          <i className={`fa fa-${icon.token} icon-card`} />
        </span>
        <span className="categoria title">{category.title}</span>
      </Container>
      <Container className="info" narrow>
        <Container className="cabecalho">
          <h1 className="title">{title}</h1>
          <span className="description">{description}</span>
        </Container>
        <Container className="acao">
          <Button>{content.cta_label}</Button>
        </Container>
      </Container>
      <Container className="corpo" narrow>
        <Accordion>
          {allSections.map((section, idx) => (
            <AccordionSection
              key={idx}
              idx={idx}
              title={section.title}
              content={section.content}
              isActive={activeIndex === idx}
              handleClick={handleClick}
            />
          ))}
        </Accordion>
      </Container>
      <Tags tags={content.tags} />
    </Container>
  );
};

export default ServicoView;
